import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';

const API_BASE = getApiBaseUrl();

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        Authorization: token ? `Bearer ${token}` : '',
    };
};

export const fetchPaymentsOverview = () =>
    axios.get(`${API_BASE}/api/payments/overview`, {
        headers: getAuthHeaders(),
    });

export const fetchMonthlyReports = () =>
    axios.get(`${API_BASE}/api/payments/monthly-report`, {
        headers: getAuthHeaders(),
    });

export const fetchOrders = (page = 1, limit = 10) =>
    axios.get(`${API_BASE}/api/orders?page=${page}&limit=${limit}`, {
        headers: getAuthHeaders(),
    });

export const createOrder = (orderData) =>
    axios.post(`${API_BASE}/api/orders`, orderData, {
        headers: getAuthHeaders(),
    });

export const updateOrder = (id, updateData) =>
    axios.put(`${API_BASE}/api/orders/${id}`, updateData, {
        headers: getAuthHeaders(),
    });

export const deleteOrder = (id) =>
    axios.delete(`${API_BASE}/api/orders/${id}`, {
        headers: getAuthHeaders(),
    });

export const fetchAnalytics = () =>
    axios.get(`${API_BASE}/api/payments/analytics`, {
        headers: getAuthHeaders(),
    });
